import { SelectItem, useDiscLocationsQuery } from '@kistill/client/data-access'
import { Grid, TextFieldProps } from '@mui/material'
import { AutocompleteElement } from 'react-hook-form-mui'

interface DiscLocationSelectorProps {
  name: string
  label: string
  inputProps?: TextFieldProps
}

export function KistillDiscLocationSelector({
  name,
  label,
}: DiscLocationSelectorProps) {
  const { data } = useDiscLocationsQuery({
    fetchPolicy: 'network-only',
  })

  const discLocationOptions = data?.discLocationOptions?.map((x) => {
    return { id: x.id, label: x.title } as unknown as SelectItem
  })

  return (
    <Grid item container alignItems='center'>
      <Grid item xs={12}>
        <AutocompleteElement
          multiple
          name={`${name}`}
          label={label}
          options={discLocationOptions || []}
        />
      </Grid>
    </Grid>
  )
}
